import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Typography } from '@mui/material';

import { BLACK, RED } from '../../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../../theme/fontConstants';
import { isContractExpired } from '../helpers/contractDataTransformers';

const ContractCardHeader = ({ contract, transformedContract }) => (
  <Box>
    <Box display="flex" gap={1} direction="column" alignItems="center">
      <Typography
        sx={{
          fontSize: '24px',
          fontFamily: PRIMARY_FONT[700],
          color: BLACK[100],
          lineHeight: '24px',
        }}
      >
        {transformedContract?.corporationName}
      </Typography>
      {isContractExpired(contract) && (
        <Typography
          sx={{
            fontSize: '16px',
            fontFamily: PRIMARY_FONT[500],
            color: RED[50],
            fontStyle: 'italic',
          }}
        >
          {LanguageConverterV2('contractCard.expiredContract')}
        </Typography>
      )}
    </Box>

    <Typography
      sx={{
        fontSize: '16px',
        fontFamily: PRIMARY_FONT[400],
        color: BLACK[100],
        marginBottom: '4px',
      }}
    >
      {transformedContract?.agencyName}
    </Typography>
  </Box>
);

ContractCardHeader.propTypes = {
  contract: PropTypes.shape({
    timeWindow: PropTypes.shape({
      end: PropTypes.number,
    }),
  }),
  transformedContract: PropTypes.shape({
    corporationName: PropTypes.string,
    agencyName: PropTypes.string,
  }),
};

export default ContractCardHeader;
